import React from 'react';

const SecurityBadges = ({ className = '' }) => {
  return (
    <div className={`flex flex-col items-center text-center space-y-4 ${className}`}>
      <p className="text-xs text-muted-foreground">
        Your data is protected with industry-standard security measures
      </p>
    </div>
  );
};

export default SecurityBadges;
